// Reused single offscreen canvas for text measurement — avoids creating a
// new <canvas> on every call.
let _measureCanvas = null;
const getMeasureContext = () => {
  if (!_measureCanvas) {
    _measureCanvas = document.createElement('canvas');
  }
  return _measureCanvas.getContext('2d');
};

// Measures the actual rendered width of a text string for a given
// font size/family/weight/style — this is what the browser will really
// draw, so it's far more reliable than a fixed "average char width"
// guess (which breaks for large font sizes, bold/narrow fonts, etc).
export const measureTextWidth = (text, fontSize, fontFamily = 'Arial', bold = false, italic = false) => {
  const ctx = getMeasureContext();
  if (!ctx) return (text?.length || 0) * (fontSize || 16) * 0.6; // SSR / no-canvas fallback

  ctx.font = `${italic ? 'italic ' : ''}${bold ? '700 ' : '400 '}${fontSize || 16}px ${fontFamily || 'Arial'}`;
  return ctx.measureText(text || '').width;
};